import React from 'react';
import classes from './WrFreelance.module.css'


const WrFreelance = () => {
    return (
        <section className={classes.wrFreelance}>
            <div className={classes.container}>
                <h1>I Am Available For Freelance</h1>
                <button><a href="#">HIRE ME</a></button>
            </div>

        </section>
    );
}

export default WrFreelance;
